import { Platform } from 'react-native'

// Both requests authorize with the passed userToken instead of the current
// session token: after logout the session token is already removed, and during
// account switch it belongs to the NEW user, which would make the backend
// delete the new user's binding as well (server adds current_user to the scope).

/**
 * 将 JPush registrationID 绑定到指定用户
 * @param registrationID JPush 注册 ID
 * @param userToken 用户 token
 */
export async function bindJPushRegistrationID(registrationID: string, userToken: string): Promise<Response> {
  const payload = {
    registration_id: registrationID,
    model: Platform.OS,
    account_tokens: [userToken],
    platform: 'cyborg',
  }

  console.log('[JPush API] 发送请求到:', `${process.env.EXPO_PUBLIC_API_BASE_URL}/api/v2/push_notification_tokens`)
  console.log('[JPush API] Payload:', payload)

  const response = await fetch(`${process.env.EXPO_PUBLIC_API_BASE_URL}/api/v2/push_notification_tokens`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: userToken,
    },
    body: JSON.stringify(payload),
  })

  console.log('[JPush] 绑定 API 响应状态:', response.status, response.statusText)

  if (response.ok) {
    const responseData = await response.json().catch(() => null)
    console.log('[JPush] ✅ RegistrationID 绑定成功，响应:', responseData)
  } else {
    const errorText = await response.text().catch(() => '无法读取错误信息')
    console.error('[JPush] ❌ RegistrationID 绑定失败:', response.status, response.statusText, errorText)
  }

  return response
}

/**
 * 解绑 JPush registrationID
 * @param registrationID JPush 注册 ID
 * @param userToken 用户 token
 */
export async function unbindJPushRegistrationID(registrationID: string, userToken: string): Promise<Response> {
  const payload = {
    account_tokens: [userToken],
    platform: 'cyborg',
  }

  console.log('[JPush API] 发送解绑请求:', registrationID)
  console.log('[JPush API] Payload:', payload)

  const response = await fetch(
    `${process.env.EXPO_PUBLIC_API_BASE_URL}/api/v2/push_notification_tokens/${registrationID}`,
    {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: userToken,
      },
      body: JSON.stringify(payload),
    }
  )

  console.log('[JPush] 解绑 API 响应状态:', response.status, response.statusText)

  if (response.ok) {
    console.log('[JPush] ✅ RegistrationID 解绑成功')
  } else {
    const errorText = await response.text().catch(() => '无法读取错误信息')
    console.error('[JPush] ❌ RegistrationID 解绑失败:', response.status, response.statusText, errorText)
  }

  return response
}
